import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/order/back-office/find-parcel`;

const search = async (params) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

export default { search };
